import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Select,
  SelectProps,
  Text,
  Textarea,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDebouncedState } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBuildingStore,
  IconCalendar,
  IconCheck,
  IconMapPin2,
  IconMapStar,
  IconSearch,
  IconSquareXFilled,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  _timerDelayClick,
  repositoryMdm,
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import InputSearch from "../../../common/InputSearch/InputSearch";
import { _localization } from "../../../config/location";
import { ComboboxItem } from "../../../model/ComboboxItem";
import { MessageResponse } from "../../../model/MessageResponse";
import { getProvinceSelect } from "../../../service/getSelectApi";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

export interface TblWarrantyReceipt {
  id: number;
  customerName: string | null;
  phoneNumber: string | null;
  email: string | null;
  provinceId: number | string | null;
  districtId: number | string | null;
  communeId: number | string | null;
  address: string | null;
  quantity: number | null;
  itemNote?: string | null;
  errorNote?: string | null;
  status?: string | null;
  attribute1: string | null;
  attribute2?: string | null;
  attribute3?: string | null;
  attribute4?: string | null;
  attribute5?: string | null;
  attribute6?: string | null;
  attribute7?: string | null;
  attribute8?: string | null;
  attribute9?: string | null;
  attribute10?: string | null;
  createBy?: number | null;
  createDate?: string | null; // hoặc Date nếu bạn parse về Date
  lastUpdateBy?: number | null;
  lastUpdateDate?: string | null; // hoặc Date nếu bạn parse về Date
}
export interface noteClose {
  id: number;
  CloseNote: string;
}

interface UserLogin {
  branchId: number;
  // bạn có thể thêm các field khác nếu cần
}

const WarrantyClaimInformation = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblWarrantyReceipt[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [pagination, setPagination] = useState(paginationBase);
  const [isFirstFetch, setIsFirstFetch] = useState(true);
  const [dataProvinceSelect, setDataProvinceSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [branchId, setBranchId] = useState<number | null>(null);
  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };
  const [dataBranch, setDataBranch] = useState<SelectListItemBase[]>([]);
  const dataWarrantyClaimFrom = [
    {
      label: "WEBSITE",
      value: "YEU_CAU_BAO_HANH_WEBSITE",
    },
    {
      label: "POS",
      value: "YEU_CAU_BAO_HANH_POS",
    },
  ];

  const userLoginString = localStorage.getItem("userLogin");

  const userLogin =
    userLoginString !== null ? JSON.parse(userLoginString) : null;

  const navigate = useNavigate();
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const [search, setSearch] = useState<any>({
    branchId:
      _searchJson && checkedPinSearch
        ? _searchJson?.branchId
        : userLogin?.branchId,
    status: _searchJson && checkedPinSearch ? _searchJson?.status : "",
    startDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.startDate
        : new Date(
            new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
              7 * 60 * 60 * 1000,
          )?.toISOString(),
    endDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.endDate
        : new Date(new Date().getTime() + 7 * 60 * 60 * 1000)?.toISOString(),
    ProvinceId: _searchJson && checkedPinSearch ? _searchJson?.ProvinceId : "",
    LoaiBaoHanh:
      _searchJson && checkedPinSearch ? _searchJson?.LoaiBaoHanh : "",
  });

  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );

  const handleChangeSearchValue = (value: string, key: string) => {
    setSearch((prevData: any) => ({ ...prevData, [key]: value }));
  };

  const optionColorWarrantyClaimFrom: Record<"WEBSITE" | "POS", string> = {
    WEBSITE: "blue",
    POS: "green",
  };

  const renderSelectOptionWarrantyClaimFrom: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={optionColorWarrantyClaimFrom[option.label as "WEBSITE" | "POS"]}
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const handleCreatePromotion = async (dataSubmit: noteClose) => {
    try {
      const dataApi = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/TblWarrantyReceipt/close",
        dataSubmit,
      );
      if (dataApi && dataApi.success) {
        NotificationExtension.Success("Đóng phiếu thành công");
      }
      setTimeout(() => {
        getDataCustMeeting();
      }, 2000);
    } catch (error) {
      NotificationExtension.Success("Đóng phiếu thất bại");
      console.log(error);
    }
  };

  const CancelWarrantyModal = ({ data }: { data: TblWarrantyReceipt }) => {
    const modalForm = useForm<noteClose>({
      initialValues: {
        id: data?.id,
        CloseNote: "",
      },
      validate: {
        CloseNote: (value) => (value ? null : "Vui lòng nhập lý do"),
      },
    });

    return (
      <form
        onSubmit={modalForm.onSubmit(async (values) => {
          await handleCreatePromotion(values);
          modals.closeAll();
        })}
      >
        <Textarea
          minRows={2}
          maxRows={4}
          mt={5}
          label="Lý do hủy"
          placeholder="Nhập lý do hủy"
          {...modalForm.getInputProps("CloseNote")}
        />
        <Group justify="flex-end" mt="md">
          <Button
            leftSection={<IconCheck size={14} />}
            color="blue"
            variant="filled"
            type="submit"
          >
            Xác nhận
          </Button>
          <Button variant="default" onClick={() => modals.closeAll()}>
            Hủy
          </Button>
        </Group>
      </form>
    );
  };

  const openModal = (data: TblWarrantyReceipt) => {
    modals.openConfirmModal({
      title: <Title order={4}>Hủy yêu cầu bảo hành</Title>,
      size: "lg",
      children: <CancelWarrantyModal data={data} />,
      withCloseButton: false,
      closeOnConfirm: false,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  //#region  table
  const columns = React.useMemo<MRT_ColumnDef<TblWarrantyReceipt>[]>(
    () => [
      {
        accessorKey: "attribute2",
        header: "STT chờ",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        //sortingFn: "basic",
        size: 100,
      },
      {
        accessorKey: "loaiBaoHanh",
        header: "Yêu cầu bảo hành từ",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge
              color={
                renderedCellValue === "YEU_CAU_BAO_HANH_WEBSITE"
                  ? "blue"
                  : "green"
              }
            >
              {renderedCellValue === "YEU_CAU_BAO_HANH_WEBSITE"
                ? "Website"
                : "POS"}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "attribute1",
        header: "Tên Chi nhánh",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row, renderedCellValue }) => {
          const a = dataBranch.find((x) => x.value === renderedCellValue);
          return <>{[renderedCellValue] + " - " + a?.text || ""}</>;
        },
      },
      {
        accessorKey: "status",
        header: "Trạng thái",
        size: 120,
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => {
          let color = "gray";
          let label = "Không xác định";

          switch (renderedCellValue) {
            case "TAO_MOI":
              color = "violet";
              label = "Tạo mới";
              break;
            case "DA_TIEP_NHAP":
              color = "orange";
              label = "Đã tiếp nhận";
              break;
            case "DA_XU_LY":
              color = "blue";
              label = "Đã xử lý";
              break;
            case "DA_DONG":
              color = "red";
              label = "Đã đóng";
              break;
            default:
              break;
          }

          return (
            <Badge
              size="sm"
              variant="light"
              bd={`1px solid ${color}`}
              color={color}
            >
              {label}
            </Badge>
          );
        },
      },
      {
        accessorKey: "createDate",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        header: "Ngày tạo",
        size: 140,
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "lastUpdateDate",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        header: "Ngày cập nhật cuối",
        size: 140,
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },

      {
        accessorKey: "customerName",
        header: "Họ và tên",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "phoneNumber",
        header: "Số điện thoại",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "itemNote",
        header: "Sản phẩm bảo hành",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "quantity",
        header: "Số lượng sản phẩm",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "attribute4",
        header: "Nội dung yêu cầu",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "attribute3",
        header: "Lý do hủy",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 300,
      },
      {
        accessorKey: "provinceName",
        header: "Tỉnh/Thành Phố",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "communeName",
        header: "Phường/Xã",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
      },

      {
        accessorKey: "address",
        header: "Địa chỉ cụ thể",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "actions",
        header: "Thao tác",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 80,
        Cell: ({ row, renderedCellValue }) => (
          <Flex justify="center" align="center">
            <Tooltip label="Hủy yêu cầu">
              <ActionIcon
                onClick={() => openModal(row.original)}
                variant="light"
                color="red"
                disabled={["DA_DONG", "DA_TIEP_NHAP"].includes(
                  row.original.status ?? "",
                )}
              >
                <IconSquareXFilled size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Flex>
        ),
      },
    ],
    [dataBranch, pagination],
  );

  const fetchDataBranch = async () => {
    const response = await repositoryPos.get<
      MessageResponse<SelectListItemBase[]>
    >("/api/v1/TblDmInventory/get-select-branch?auth=false");

    if (response && response.success) {
      let result = response.data;
      setDataBranch(result);
    }
  };

  const getDataProvinceSelect = async () => {
    const getData = await getProvinceSelect();
    setDataProvinceSelect(
      getData
        ?.filter((item: any) => item.value != null && item.text != null)
        ?.map((item: any) => ({
          value: item.value,
          label: item.text,
        })),
    );
  };

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const getDataCustMeeting = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.branchId) {
      url += `&BranchId=${search.branchId}`;
    }

    if (keySearch) {
      url += `&KeySearch=${keySearch}`;
    }
    if (search.startDate) {
      url += `&FromDate=${search.startDate}`;
    }

    if (search.endDate) {
      url += `&ToDate=${search.endDate}`;
    }
    if (search.ProvinceId) {
      url += `&ProvinceId=${search.ProvinceId}`;
    }

    if (search.status) {
      url += `&Status=${search.status}`;
    }

    if (search.LoaiBaoHanh) {
      url += `&LoaiBaoHanh=${search.LoaiBaoHanh}`;
    }
    try {
      const response = await repositoryMdm.get(
        `/api/v1/TblWarrantyReceipt/get-list${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount ?? 0);
        // setSelectIds([]);
        // table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        }),
      );
    }
    startCountdown();
  };

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningWarrantyClaimInformation",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["STTs"],
          right: ["actions"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );

  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningWarrantyClaimInformation",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  const table = useMantineReactTable({
    columns,
    data,
    manualSorting: false, // client-side sorting
    enableSorting: true,
    positionToolbarAlertBanner: "bottom",
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    //add custom action buttons to top-left of top toolbar
    renderToolbarInternalActions: () => <></>,
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      // sorting: [
      //   { id: "attribute2", desc: true }, // sắp xếp attribute2 giảm dần
      // ],
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount,
    onPaginationChange: setPagination,
    manualFiltering: false,
    manualPagination: true,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["5", "25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  useEffect(() => {
    fetchDataBranch();
    getDataProvinceSelect();
  }, []);

  useEffect(() => {
    if (pagination) {
      getDataCustMeeting();
    }
  }, [pagination]);

  useEffect(() => {
    const userLoginString = localStorage.getItem("userLogin");
    if (userLoginString) {
      try {
        const user: UserLogin = JSON.parse(userLoginString);
        if (user?.branchId) {
          setBranchId(user.branchId);
        }
      } catch (error) {
        console.error("Lỗi khi parse localStorage user-login:", error);
      }
    }
  }, []);

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList?.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (180 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  // React.useEffect(() => {
  //   const newColumnVisibility = getColumnVisibility();
  //   if (table) {
  //     table.setColumnVisibility(newColumnVisibility);
  //   }
  // }, [table]);

  return (
    <>
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "10px",
          position: "relative",
        }}
        ref={headerRef}
      >
        <_breadcrumb></_breadcrumb>
        <Grid mt={10}>
          <Grid.Col span={sizeGrid}>
            <InputSearch
              width="100%"
              placeholder="Từ khoá"
              defaultValue={keySearch}
              onChange={(value) => {
                setKeySearch(value);
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              value={search.startDate ? new Date(search.startDate) : null}
              leftSection={<IconCalendar color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "startDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              value={search.endDate ? new Date(search.endDate) : null}
              leftSection={<IconCalendar color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "endDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              searchable
              clearable
              placeholder="Chọn chi nhánh"
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              value={
                dataBranch?.find(
                  (item: SelectListItemBase) =>
                    item.value === String(search.branchId),
                )?.value || null
              }
              leftSection={<IconBuildingStore color="#15aabf" />}
              nothingFoundMessage={"Loading..."}
              data={dataBranch
                ?.sort((a: any, b: any) => a.att2 - b.att2)
                .map((ele, index) => {
                  return {
                    label: ele.text,
                    value: ele.value,
                  };
                })
                .slice(1)}
              onChange={(value) => {
                handleChangeSearchValue(value || "", "branchId");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              searchable
              clearable
              placeholder="Chọn trạng thái"
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              leftSection={<IconBuildingStore color="#15aabf" />}
              nothingFoundMessage={"Loading..."}
              value={search.status || null}
              data={[
                { label: "Tạo mới", value: "TAO_MOI" },
                { label: "Đã tiếp nhận", value: "DA_TIEP_NHAP" },
                { label: "Đã đóng", value: "DA_DONG" },
              ]}
              onChange={(value) => {
                handleChangeSearchValue(value || "", "status");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              searchable
              clearable
              placeholder="Chọn tỉnh thành"
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              leftSection={<IconMapStar color="#15aabf" />}
              nothingFoundMessage={"Loading..."}
              value={search.ProvinceId || null}
              data={dataProvinceSelect
                ?.sort((a: any, b: any) => a.att2 - b.att2)
                .map((ele, index) => {
                  return {
                    label: ele.label,
                    value: ele.value,
                  };
                })
                .slice(1)}
              onChange={(value) => {
                handleChangeSearchValue(value || "", "ProvinceId");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              placeholder="Yêu cầu bảo hành từ"
              data={dataWarrantyClaimFrom}
              leftSection={<IconMapPin2 color="#15aabf" />}
              value={search.LoaiBaoHanh || null}
              onChange={(value) =>
                handleChangeSearchValue(value || "", "LoaiBaoHanh")
              }
              renderOption={renderSelectOptionWarrantyClaimFrom}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={() => {
                getDataCustMeeting();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box pt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default WarrantyClaimInformation;
